export default __webpack_public_path__ + "static/media/saoviet.4ef54ea2.jpg";